import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import type { IListCountProps } from './IListCountProps';

/**
 * Рядок «N записів» подань без пагінації (прототип v4 L997): моноширинний 12px приглушений із лінією зверху й відступом 14px зверху; над
 * дошкою й календарем подання йде одразу під ним (без нижнього відступу), під таблицею етапів — після таблиці.
 */
export function ListCount({ total, placement }: IListCountProps) {
  const { t } = useTranslation();
  return <div className={cx('lv-count', placement === 'above' ? 'lv-count--above' : 'lv-count--below')}>{t('modules.records', { count: total })}</div>;
}
